import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, Input, Spinner, } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { adjustSelectedDateRange, formatDate, getCurrentFiscalYearDates, getPast30DaysRange, getWorkingDateRange } from "../Common/WorkingDateRange";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";
import { contractNote_listThunk } from "../../slices/thunks";
import { showToast } from "../ToastNotification";
import { useSelector } from "react-redux";

const ContractNoteModal = ({ showModal, onCloseClick }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const { userData } = usePersistStoreData();
    const token = userData?.token;
    const { startDate: defaultStart, endDate: defaultEnd } = getPast30DaysRange();
  const [dateRange, setDateRange] = useState([defaultStart, defaultEnd]);
  
  const [selectedContractType, setSelectedContractType] = useState("digital");

  const {  contractNote_listLoading } = useSelector(
    (state) => state.ContractNote_List
  );

  const handleContractNoteList = () => {
    return new Promise((resolve, reject) => {
      if (!dateRange || dateRange.length !== 2) {
        showToast("Please select a valid date range.", "error");
        reject(new Error("Invalid date range"));
        return;
      }
      
      const start_date = formatDate(dateRange[0]);
      const end_date = formatDate(dateRange[1]);
      
      // Dispatch the API call and handle the response
      dispatch(
        contractNote_listThunk({
          token,
          params: {
            contract_type: selectedContractType,
            start_date,
            end_date,
          },
        })
      )
      .unwrap() // This is important if using createAsyncThunk
      .then(response => {
        // Check for success status
        if (response && response.code === 200) {
          resolve(response);
        } else {
          showToast("Something went wrong. Please try again.", "error");
          reject(new Error("API response was not successful"));
        }
      })
      .catch(error => {
        showToast("Something went wrong. Please try again.", "error");
        reject(error);
      });
    });
  };


  return (
    <Modal isOpen={showModal} 
    
    
     centered={true}
    backdrop="static"  
    keyboard={false}
    className="contact_modal_custom"
    >
      <ModalHeader
       style={{ backgroundColor: '#0F528D',  paddingTop:"0.75rem",
      paddingBottom:"0.75rem",
      }}
      //  className="d-flex align-items-center"
      ><span className="fs-16 contact_note_header "
      style={{
      
        
      }}
      >Contract Note</span></ModalHeader>
      <ModalBody className="">
      <div className="mb-2">
                <label htmlFor="type" className="col-form-label pt-0">
                 Select Contract Note Type
                </label>
                <Input
                  type="select"
                  id="type"
                  name="type"
                  className="form-control cursor-pointer"
                  value={selectedContractType}
          onChange={(e) => setSelectedContractType(e.target.value)}
                  
                >
                    <option value="digital_com">Digital Commodity</option>
            <option value="digital">Digital</option>
                </Input>
                
              </div>

              <div className=" mb-3">
                <label htmlFor="pan_no" className="col-form-label">
                  Select Dates
                </label>
                <div className="date-box">
                <Flatpickr
            style={{
              backgroundColor: "#F1F4F7",
              border: "1px solid transparent",
            }}
            options={{
              mode: "range",
              dateFormat: "d-m-Y",
              
              maxDate: new Date(new Date().setDate(new Date().getDate() - 1)), // T-1
              onClose: (selectedDates, dateStr, instance) => {
                if (selectedDates.length === 1) {
                  // Reset to default date range
                  const defaultDates = [defaultStart, defaultEnd];
                  setDateRange(defaultDates);
                  instance.setDate(defaultDates);
                  return;
                }
                if (selectedDates.length === 2) {
                  if (selectedDates[0].getTime() === selectedDates[1].getTime()) {
                    // Reset to default date range
                    const defaultDates = [defaultStart, defaultEnd];
                    setDateRange(defaultDates);
                    instance.setDate(defaultDates);
                    showToast(
                      "Please select a range with different start and end dates.",
                      "error"
                    );
                    return;
                  }
                  const diffInDays =
                    (selectedDates[1] - selectedDates[0]) / (1000 * 60 * 60 * 24);
                  if (diffInDays > 29) {
                    instance.clear();
                    showToast("You can only select a maximum range of 30 days.", "error");
                  }
                }
              },
            }}
            value={dateRange}
          onChange={(selectedDates) => {
            // Update the state to reflect the selected date range
            setDateRange(selectedDates);
          }}
            className="form-control"
          />
               <i className="bx bx-calendar date-icon fs-20"></i> 
              </div>
              </div>

        <div className="d-flex gap-3 justify-content-center mt-3 mb-0">
        <button
            type="button"
            className="btn border w-sm centerContent"
            data-bs-dismiss="modal"
            style={{ 
              backgroundColor: "#FFFFFF",
              minWidth:"170px" 
          
          }}
            onClick={() => {
             navigate("/dashboard")
            }}
          >
            Back to Dashboard
          </button>
          
          <button
            type="button"
            className="btn  btn-primary"
            data-bs-dismiss="modal"
            style={{
              minWidth:"170px"
            }}
            onClick={() => {
              handleContractNoteList()
                .then(() => {
                  onCloseClick(); // Only called when API call succeeds
                })
                .catch((error) => {
                  console.error(error); 
                });
            }}
            disabled={contractNote_listLoading}
          >
            {contractNote_listLoading ? <Spinner size="sm" />: "Continue"}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ContractNoteModal;
